module.exports = __webpack_public_path__ + "media/images/emblems/Gurbrue-coat_of_arms-343126353d1e47736c18ec11a4fe3853.svg";